import './Kontakt.css';

function Kontakt() {
  return (
    <footer className="footerDiv" id="kontakt">
      <div>
        <br></br>
        <p>
          Nehmen Sie Kontakt zum VdHR auf, wir freuen uns darüber und antworten
          gern!
        </p>
        <a href="mailto: kontakt@vdhr.info">
          <b>kontakt@vdhr.info</b>
        </a>
        <br></br>
        <br></br>
      </div>
    </footer>
  );
}

export default Kontakt;
